import { Dispatch, SetStateAction, JSX } from 'react';
import { MdOutlineTableRows, MdShowChart } from 'react-icons/md';
import { DownloadDropdown } from '@Components/DownloadDropdown';
import { Dropdown } from '@Components/Dropdown';
import { Design, Placement, Size } from '@Components/designConstants';
import { IconSegmentedControlButton } from '@Components/SegmentedControlButton';

interface ModeledRightActionsProps {
  viewType: 'absolute' | 'relative';
  setViewType: Dispatch<SetStateAction<'absolute' | 'relative'>>;
  modeledDropdownValue: 'Marketing Outcomes' | 'Channel Mix';
  showModeledGraphView: boolean;
  setShowModeledGraphView: Dispatch<SetStateAction<boolean>>;
}

export const ModeledRightActions = ({
  viewType,
  setViewType,
  modeledDropdownValue,
  showModeledGraphView,
  setShowModeledGraphView
}: ModeledRightActionsProps): JSX.Element => (
  <div className='ef-modeled-right-actions'>
    {modeledDropdownValue === 'Channel Mix' && (
      <div className='ef-channel-spend-view-toggle'>
        <Dropdown
          overlayPlacement={Placement.RIGHT}
          options={[
            { label: 'Absolute', value: 'absolute' },
            { label: 'Relative', value: 'relative' }
          ]}
          onChange={option => setViewType(option)}
          value={viewType}
          label='View'

          size={Size.SM}
        />
      </div>
    )}
    <IconSegmentedControlButton
      options={[
        { key: 'showTable', icon: <MdOutlineTableRows />, label: 'table view' },
        { key: 'showGraph', icon: <MdShowChart />, label: 'graph view' }
      ]}
      selectedOption={showModeledGraphView ? 'showGraph' : 'showTable'}
      onChange={value => setShowModeledGraphView(value === 'showGraph')}
      size={Size.SM}
      design={Design.NEUTRAL}
    />
    <DownloadDropdown
      size={Size.SM}
      onClickOptions={[() => {}, () => {}]}
      disabledMenuOptions={
        showModeledGraphView ? { XLSX: false, PNG: false } : { XLSX: false, PNG: true }
      }
    />
  </div>
);
